import {
    CollectionReference,
    DocumentData,
    Query,
    QuerySnapshot,
    onSnapshot,
} from 'firebase/firestore'
import { useEffect, useState } from 'react'

const cache: { [key: string]: any } = {}

const useCollectionQuery: (
    key: string,
    collection: CollectionReference | Query<DocumentData>
) => { loading: boolean; error: boolean; data: QuerySnapshot | null } = (
    key,
    collection
) => {
    const [data, setData] = useState<QuerySnapshot<DocumentData> | null>(
        cache[key] || null
    )

    const [loading, setLoading] = useState(!data)
    const [error, setError] = useState(false)

    useEffect(() => {
        const unsubscribe = onSnapshot(
            collection,
            (snapshot) => {
                setData(snapshot)
                setLoading(false)
                setError(false)
                cache[key] = snapshot
            },
            (err) => {
                console.error(err)
                setData(null)
                setLoading(false)
                setError(true)
            }
        )

        return () => {
            unsubscribe()
        }
    }, [key])

    return { loading, error, data }
}

export default useCollectionQuery
